<div class="app-container">

  <header class="header-container">
    <app-header #sidenav></app-header>
  </header>

  <main class="main-container" [ngClass]="headerChange ? 'main-container-thin': ''" (click)="sidenav.dismissSidebar()">
    <router-outlet></router-outlet>
  </main>

  <footer class="footer-container" (click)="sidenav.dismissSidebar()" *ngIf="footerChange">
    <app-footer></app-footer>
  </footer>

</div>